import { render, staticRenderFns } from "./ChatLogs.vue?vue&type=template&id=5751a092&scoped=true"
import script from "./ChatLogs.vue?vue&type=script&lang=js"
export * from "./ChatLogs.vue?vue&type=script&lang=js"
import style0 from "./ChatLogs.vue?vue&type=style&index=0&id=5751a092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5751a092",
  null
  
)

export default component.exports